import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage'; // 📦 1. Importas Storage

// React leerá automáticamente el .env correcto dependiendo de si usas 'start' o 'build'
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Inicializamos Firebase con la configuración dinámica
const app = initializeApp(firebaseConfig);

// Exportamos los servicios para usarlos en App.js
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app); // 📦 2. Exportas Storage para que App.js lo use